export const ERROR_COPY_ROOT = 'collect_package.errors';
export const DEFAULT_ERROR_KEY = 'went_wrong';
